import AmioHttpService from '@/services/amio/amio-http.service'

class IndexesService extends AmioHttpService {
  async create(name, sources, scheduleParams = null) {
    const payload = { name, sources }
    if (scheduleParams) payload.schedule_params = scheduleParams
    try {
      const response = await this.requestPost('/indexes', payload)
      return response.data
    } catch (err) {
      throw this.handleError(err)
    }
  }

  async update(id, patchData) {
    try {
      const response = await this.requestPatch(`/indexes/${id}`, patchData)
      return response.data
    } catch (err) {
      throw this.handleError(err)
    }
  }

  async list() {
    try {
      const response = await this.requestGet('/indexes')
      return response.data
    } catch (err) {
      throw this.handleError(err)
    }
  }

  async delete(id) {
    try {
      await this.requestDelete(`/indexes/${id}`)
    } catch (err) {
      throw this.handleError(err)
    }
  }

}

export default new IndexesService()
